export default "__VITE_ASSET__DUi7hX_D__"